import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, useTemplateRef, onMounted } from 'vue';

import NcDialog from '@nextcloud/vue/components/NcDialog';
import NcTextField from '@nextcloud/vue/components/NcTextField';

import { translate as t } from '@services/l10n';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'PromptDialog',
},
  __name: 'PromptDialog',
  props: {
    title: { default: '' },
    message: { default: '' },
    label: { default: '' },
    password: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const input = useTemplateRef<{ focus?: () => void }>('input');

const value = ref('');

const buttons = computed(() => [
  {
    label: t('memories', 'Cancel'),
    callback: () => close(null),
  },
  {
    label: t('memories', 'OK'),
    variant: 'primary' as const,
    callback: () => submit(),
  },
]);

onMounted(() => {
  input.value?.focus?.();
});

function submit() {
  close(value.value);
}

function close(closeValue: string | null) {
  emit('close', closeValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcDialog), {
    name: __props.title,
    message: __props.message,
    buttons: buttons.value,
    onClosing: _cache[1] || (_cache[1] = ($event: any) => (close(null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NcTextField), {
        ref_key: "input",
        ref: input,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        label: __props.label,
        type: __props.password ? 'password' : 'text',
        onKeydown: _withKeys(submit, ["enter"])
      }, null, 8, ["modelValue", "label", "type"])
    ]),
    _: 1
  }, 8, ["name", "message", "buttons"]))
}
}

})